import * as ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem from './media-enterprise-public-media-v1-enterprise-item-enterprise-media-items.http.js';
import * as ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes from './media-enterprise-public-media-v1-enterprise-item-enterprise-media-items.types.js';
import * as ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes from './media-enterprise-public-media-v1-enterprise-item-enterprise-media-items.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function itemUploadCallback(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.ItemUploadCallbackRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.ItemUploadCallbackRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.ItemUploadCallbackResponse,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.ItemUploadCallbackResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.itemUploadCallback(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/enterprise/items/upload/callback',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function generateFileUploadUrl(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.GenerateFileUploadUrlRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.GenerateFileUploadUrlRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.GenerateFileUploadUrlResponse,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.GenerateFileUploadUrlResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.generateFileUploadUrl(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/enterprise/items/upload/generate-url',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function importFile(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.ImportFileRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.ImportFileRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.ImportFileResponse,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.ImportFileResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.importFile(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/enterprise/items/upload/import',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkImportFiles(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.BulkImportFilesRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.BulkImportFilesRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.BulkImportFilesResponse,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.BulkImportFilesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.bulkImportFiles(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/files/import',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.SearchItemsRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.SearchItemsRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.SearchItemsResponse,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.SearchItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.searchItems(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/enterprise/items/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.QueryItemsRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.QueryItemsRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.QueryItemsResponse,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.QueryItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.queryItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/enterprise/items/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateItem(): __PublicMethodMetaInfo<
  'PATCH',
  { itemId: string },
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.UpdateItemRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.UpdateItemRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.UpdateItemResponse,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.UpdateItemResponse
> {
  const payload = { item: { id: ':itemId' } } as any;

  const getRequestOptions =
    ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.updateItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/enterprise/items/{item.id}',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateItem(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.BulkUpdateItemRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.BulkUpdateItemRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.BulkUpdateItemResponse,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.BulkUpdateItemResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.bulkUpdateItem(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/bulk/enterprise/items/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getItem(): __PublicMethodMetaInfo<
  'GET',
  { itemId: string },
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.GetItemRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.GetItemRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.GetItemResponse,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.GetItemResponse
> {
  const payload = { itemId: ':itemId' } as any;

  const getRequestOptions =
    ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.getItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/enterprise/items/{itemId}',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function linkItemToCategories(): __PublicMethodMetaInfo<
  'POST',
  { itemId: string },
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.LinkItemToCategoriesRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.LinkItemToCategoriesRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.LinkItemToCategoriesResponse,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.LinkItemToCategoriesResponse
> {
  const payload = { itemId: ':itemId' } as any;

  const getRequestOptions =
    ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.linkItemToCategories(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/enterprise/items/{itemId}/link-categories',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function unlinkItemFromCategories(): __PublicMethodMetaInfo<
  'POST',
  { itemId: string },
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.UnlinkItemFromCategoriesRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.UnlinkItemFromCategoriesRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.UnlinkItemFromCategoriesResponse,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.UnlinkItemFromCategoriesResponse
> {
  const payload = { itemId: ':itemId' } as any;

  const getRequestOptions =
    ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.unlinkItemFromCategories(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/enterprise/items/{itemId}/unlink-categories',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function overwriteItemCategories(): __PublicMethodMetaInfo<
  'POST',
  { itemId: string },
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.OverwriteItemCategoriesRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.OverwriteItemCategoriesRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemUniversalTypes.OverwriteItemCategoriesResponse,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItemTypes.OverwriteItemCategoriesResponse
> {
  const payload = { itemId: ':itemId' } as any;

  const getRequestOptions =
    ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.overwriteItemCategories(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/enterprise/items/{itemId}/overwrite-categories',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  EnterpriseMediaItem as EnterpriseMediaItemOriginal,
  MediaType as MediaTypeOriginal,
  MediaTypeWithLiterals as MediaTypeWithLiteralsOriginal,
  ItemAssets as ItemAssetsOriginal,
  ItemAssetsAssetsOneOf as ItemAssetsAssetsOneOfOriginal,
  Image as ImageOriginal,
  VideoV2 as VideoV2Original,
  VideoResolution as VideoResolutionOriginal,
  Audio as AudioOriginal,
  Document as DocumentOriginal,
  Archive as ArchiveOriginal,
  Model3D as Model3DOriginal,
  PublishStatus as PublishStatusOriginal,
  PublishStatusWithLiterals as PublishStatusWithLiteralsOriginal,
  ItemCategoriesChanged as ItemCategoriesChangedOriginal,
  ItemUploadCallbackRequest as ItemUploadCallbackRequestOriginal,
  ItemUploadCallbackResponse as ItemUploadCallbackResponseOriginal,
  GenerateFileUploadUrlRequest as GenerateFileUploadUrlRequestOriginal,
  GenerateFileUploadUrlResponse as GenerateFileUploadUrlResponseOriginal,
  ImportFileRequest as ImportFileRequestOriginal,
  ImportFileResponse as ImportFileResponseOriginal,
  BulkImportFilesRequest as BulkImportFilesRequestOriginal,
  BulkImportFilesResponse as BulkImportFilesResponseOriginal,
  BulkImportFilesResult as BulkImportFilesResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  SearchItemsRequest as SearchItemsRequestOriginal,
  Search as SearchOriginal,
  SearchPagingMethodOneOf as SearchPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  SearchDetails as SearchDetailsOriginal,
  Paging as PagingOriginal,
  SearchItemsResponse as SearchItemsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  QueryItemsRequest as QueryItemsRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  QueryItemsResponse as QueryItemsResponseOriginal,
  UpdateItemRequest as UpdateItemRequestOriginal,
  UpdateItemResponse as UpdateItemResponseOriginal,
  PublishStatusChanged as PublishStatusChangedOriginal,
  BulkUpdateItemRequest as BulkUpdateItemRequestOriginal,
  BulkUpdateItemResponse as BulkUpdateItemResponseOriginal,
  BulkItemUpdateResult as BulkItemUpdateResultOriginal,
  GetItemRequest as GetItemRequestOriginal,
  GetItemResponse as GetItemResponseOriginal,
  LinkItemToCategoriesRequest as LinkItemToCategoriesRequestOriginal,
  LinkItemToCategoriesResponse as LinkItemToCategoriesResponseOriginal,
  UnlinkItemFromCategoriesRequest as UnlinkItemFromCategoriesRequestOriginal,
  UnlinkItemFromCategoriesResponse as UnlinkItemFromCategoriesResponseOriginal,
  OverwriteItemCategoriesRequest as OverwriteItemCategoriesRequestOriginal,
  OverwriteItemCategoriesResponse as OverwriteItemCategoriesResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './media-enterprise-public-media-v1-enterprise-item-enterprise-media-items.types.js';
